<div id="sub-nav">
    <slot></slot>
</div>
<style>
    #sub-nav{
        background-color: var(--sub-nav-color);
        height: var(--sub-nav-height);
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: space-evenly;
        flex-direction: row;
        z-index: 2;
    }
</style>